/* global $:true */
import trackCard from '@/components/trackcard'
import VideoBox from '@/components/video_box'
import productCard from '@/components/productcard'
import VueSlickCarousel from 'vue-slick-carousel'
import contentTopHeader from '@/components/contentTopHeader'
import UserService from '@/services/user'
import MembershipTierService from '@/services/membership_tier'
import StreamService from '@/services/stream'
import AlbumService from '@/services/album'
import ProductService from "@/services/product"
import { MyEvents, ViolationsEmail, PublicRelationsUsername } from '@/helper'

export default {
  components: {
    trackCard,
    contentTopHeader,
    VideoBox,
    VueSlickCarousel,
    productCard,
  },
  data() {
    return {
      isPageReady: false,
      stripe_publishable_key: process.env.STRIPE_PUBLISHABLE_KEY,
      PublicRelationsUsername: PublicRelationsUsername,
      active_tab: '',
      slide_tab: '',
      show_following: false,     
      show_following_scroll: false,
      show_followers: false,     
      show_followers_scroll: false,
      darkMode: true,
      slug: '',
      user: {
        display_name: '',
        avatar: {},
      },
      tier: 'all',
      tierList: [],
      albums: [],
      videos: [],
      products: [],
      last_updated: null
    }
  },

  computed: {
    currentUser() {
      return this.$store.state.auth.user
    },

    onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },

  watch: {
    tier(newTier, oldTier) {
      this.getMembersAlbums()
      this.getMembersStreams()
      this.getMembersProducts()

      for (const t of this.tierList) {
        if (newTier == 'all')
          this.last_updated = null
        else if(t.value == newTier)
          this.last_updated = t.updated_at
      }
    }
  },

  methods: {
    getUserInfo() {
      const paths = window.location.href.split('/')
      this.slug = paths[paths.length - 1]
      
      UserService.getUserInfo(this.slug)
        .then((response) => {
          if (response.body.status !== 'active') {
            this.$store.dispatch('error/showErrorToast', [
              'User does not exist',
            ])
            this.$router.push({ name: 'AlbumIndex' })
            return
          }

          this.user = response.body
          this.$emit('updateHead')

          this.getTiersList()
          this.getMembersAlbums()
          this.getMembersStreams()
          this.getMembersProducts()
        })
        .catch((e) => {
          this.$store.dispatch('error/showLoadingActivity', false)
          this.$store.dispatch('error/showErrorToast', ['User does not exist'])
          this.$router.push({ path: '/' })
        })
    },

    getTiersList() {
      MembershipTierService.getTiersList(this.user.id, true)
        .then((response) => {
          let memberships = this.currentUser.memberships.map((membership) => {
            return membership.membership_tier.month_tier.id
          })

          for (const tier of response.body) {
            if (memberships.includes(tier.value) || tier.value == 'all' || this.currentUser.id == this.user.id)
              this.tierList.push(tier)
          }

        })
        .catch((e) => {
          this.$store.dispatch(
            'error/showErrorToast',
            e.body.errors || [e.body]
          )
        })
    },

    getMembersAlbums() {
      AlbumService.getMembersAlbums({
        user_id: this.user.id,
        tier: this.tier,
      }).then(response => {
        this.albums = response.body
      }).catch(e => {
        this.$store.dispatch(
          'error/showErrorToast',
          e.body.errors || [e.body]
        )
      })
    },

    getMembersStreams() {
      StreamService.getMembersStreams({
        user_id: this.user.id,
        tier: this.tier,
      }).then(response => {
        this.videos = response.body
      }).catch(e => {
        this.$store.dispatch(
          'error/showErrorToast',
          e.body.errors || [e.body]
        )
      })
    },

    getMembersProducts() {
      ProductService.getMembersProducts({
        user_id: this.user.id,
        tier: this.tier,
      }).then(response => {
        this.products = response.body
      }).catch(e => {
        this.$store.dispatch(
          'error/showErrorToast',
          e.body.errors || [e.body]
        )
      })
    },

    modeToggle() {
      let app_container = $(this.$parent.$parent.$el);
      if (this.darkMode) {
        app_container.find('.app-container').addClass('dark-mode bg-grey')
      } else {
        app_container.find('.app-container').removeClass('dark-mode bg-grey')
      }
    },

    productDisplay(product) {
       if (this.currentUser == null) {
        this.showRegisterModal = true;
      } else {
        this.$router.push({path: `/product/${product.id}`})
      }
    },
  },

  mounted() {
    this.modeToggle();
    this.getUserInfo()
  },
}



// WEBPACK FOOTER //
// ./src/views/user/members.ctrl.js